export default __webpack_public_path__ + "static/media/bean-type-mobile.93a20372.png";